import { State } from 'xstate';

import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineState,
  ProductBuilderMachineStateSchema,
} from '../types';
import { getStateKey } from './getStateKey';
import { getStates } from './getStates';

type GetPreviousState = (
  state: State<
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema
  >,
) => ProductBuilderMachineState;

export const getPreviousState: GetPreviousState = state => {
  const states = getStates(state.context);
  const currentState = getStateKey(state.value);
  return states[states.indexOf(currentState) - 1];
};
